import React from "react"
import { Box, Button, Link, Stack, Text } from "@chakra-ui/react"

interface Props {
  openExtraInfoModal: () => void
  onClose: () => void
}

export const RegisterAgeCheckMessage: React.FC<Props> = ({ openExtraInfoModal, onClose }) => {
  const [isSupervisor, setIsSupervisor] = React.useState<boolean>(true)
  return (
    <>
      {isSupervisor ? (
        <Stack pt={4}>
          <Text fontWeight="bold">Ben jij een begeleider?</Text>
          <Box pt={6}>
            <Button
              colorScheme="yellow"
              onClick={() => {
                openExtraInfoModal()
                onClose()
              }}
              mr={2}
            >
              Ja
            </Button>
            <Button colorScheme="yellow" variant="outline" onClick={() => setIsSupervisor(false)}>
              Nee
            </Button>
          </Box>
        </Stack>
      ) : (
        <Stack pt={4}>
          <Text fontWeight="bold">Hi!</Text>
          <Text>Het lijkt erop alsof je te oud of te jong bent voor Kunstbende.</Text>
          <Text>
            <b>UITZONDERING</b>: Ben je 20 jaar en zit je op de middelbare school? Dan mag je nog wel meedoen!
            Meld je dan aan via{" "}
            <Link textDecor="underline" href="mailto:hallo@kunstbende.nl">
              hallo@kunstbende.nl
            </Link>
            .
          </Text>
          <Text>
            Heb je een andere vraag of wil je samenwerken met Kunstbende? Mail ons dan vooral via hetzelfde
            mailadres.
          </Text>
          <Box pt={6}>
            <Button colorScheme="yellow" onClick={onClose}>
              Close
            </Button>
          </Box>
        </Stack>
      )}
    </>
  )
}
